import React, { useCallback } from 'react';
import { useRouteMatch, useParams, generatePath } from 'react-router-dom';
import { useI18n } from '../../../../../../data/hooks/i18nHooks';
import { Tabs, Tab } from '../../../../../elements/Tabs';
import { REQUESTED_MEETINGS_TAB, CONFIRMED_MEETINGS_TAB, SENT_MEETINGS_TAB, ALL_MEETINGS_TAB } from '../../tabs';


function MeetingsScreenHeader(props) {
    const { meetingTab } = props,
        i18n = useI18n(),
        { path } = useRouteMatch(),
        params = useParams();

    const handleTabSelection = useCallback(
        (meetingTab) => {
            const nextPath = generatePath(path, { ...params, meetingTab });
            app.history.replace(nextPath);
        },
        [path, params]
    );

    return (
        <Tabs>
            <Tab selected={meetingTab === REQUESTED_MEETINGS_TAB} onClick={() => handleTabSelection(REQUESTED_MEETINGS_TAB)}>
                {i18n['label.tab.requests']}
            </Tab>
            <Tab selected={meetingTab === CONFIRMED_MEETINGS_TAB} onClick={() => handleTabSelection(CONFIRMED_MEETINGS_TAB)}>
                {i18n['label.tab.confirmed']}
            </Tab>
            <Tab selected={meetingTab === SENT_MEETINGS_TAB} onClick={() => handleTabSelection(SENT_MEETINGS_TAB)}>
                {i18n['label.tab.sent']}
            </Tab>
            <Tab selected={meetingTab === ALL_MEETINGS_TAB} onClick={() => handleTabSelection(ALL_MEETINGS_TAB)}>
                {i18n['label.tab.all']}
            </Tab>
        </Tabs>
    );
}

export default MeetingsScreenHeader;
